import { isAndroid, isIOS } from 'react-device-detect'

import { isCurrentAppVersionAtLeast } from '@dhl/native-bridge'
import { consentGroups, getConsentedGroups } from '@dhl/onetrust'
import { isNative } from '@dhl/webview'

import { type ThirdPartyConfig } from './ThirdParty.js'

const minAppVersionRequired = '5.6.0'

export type TrackingState = {
  isOneTrustEnabled: boolean
  isOneTrustEnabledInNative: boolean
  hasAnalyticsConsent: boolean
  showTrackingScreen: boolean
}

export const useTrackingState = (config: ThirdPartyConfig, isNativeTrackingAllowed?: boolean): TrackingState => {
  const { oneTrustId, oneTrustNativeEnabled, oneTrustNativeEnabledFromVersion } = config

  const nativeOneTrustAllowedForVersion =
    isNative() && !!oneTrustNativeEnabled && isCurrentAppVersionAtLeast(oneTrustNativeEnabledFromVersion ?? '')

  const isOneTrustEnabledInBrowser = !isNative() && !!oneTrustId
  const isOneTrustEnabledInNative =
    !!oneTrustId &&
    ((nativeOneTrustAllowedForVersion && isAndroid) ||
      (nativeOneTrustAllowedForVersion && isIOS && !!isNativeTrackingAllowed))

  const isOneTrustEnabled = isOneTrustEnabledInBrowser || isOneTrustEnabledInNative
  const hasAnalyticsConsent = isOneTrustEnabled && getConsentedGroups().includes(consentGroups.analytics)

  return {
    isOneTrustEnabled,
    isOneTrustEnabledInNative,
    hasAnalyticsConsent,
    showTrackingScreen:
      isCurrentAppVersionAtLeast(minAppVersionRequired) && isNativeTrackingAllowed === undefined && isIOS,
  }
}
